import { Button, Group, Modal, Stack } from '@mantine/core';
import { zodResolver } from '@mantine/form';
import { z } from 'zod';

import { UploadFile } from '@components';
import { useUpdateWriteOffList } from '@hooks/batch';
import { useFormWithNameInputProp } from '@hooks/useFormWithNameInputProp';

const uploadWriteOffSchema = z.object({
  file: z.instanceof(File),
});

type UploadWriteOffValues = z.infer<typeof uploadWriteOffSchema>;

interface UploadWriteOffModalProps {
  opened: boolean;
  onClose: () => void;
  batchId: string;
}

export const UploadWriteOffModal: React.FC<UploadWriteOffModalProps> = ({ opened, onClose, batchId }) => {
  const updateWriteOffListMutation = useUpdateWriteOffList();

  const form = useFormWithNameInputProp<UploadWriteOffValues>({
    initialValues: {
      file: null,
    },
    validate: zodResolver(uploadWriteOffSchema),
    validateInputOnBlur: true,
  });

  const handleSubmit = async (values: UploadWriteOffValues) => {
    await updateWriteOffListMutation.mutateAsync({
      batchId,
      file: values.file,
    });
    handleClose();
  };

  const handleClose = () => {
    form.reset();
    onClose();
  };

  return (
    <Modal title="Upload Write-Off List" opened={opened} onClose={handleClose} centered zIndex={9999} size="lg">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <UploadFile {...form.getInputProps('file')} isMulti={false} type="xlsx" p="xs" />
          <Group justify="flex-end">
            <Button variant="subtle" onClick={handleClose} disabled={updateWriteOffListMutation.isPending} data-pw="cancel-upload-btn">
              Cancel
            </Button>
            <Button type="submit" disabled={!form.isValid()} loading={updateWriteOffListMutation.isPending} data-pw="submit-upload-btn">
              Upload
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};
